const KIT_REGISTRATION_RETURN_KIT_ID_KEY = 'ash.kit-registration.return-kit-id'
const KIT_REGISTRATION_RETURN_KIT_ID_PENDING_KEY = 'ash.kit-registration.return-kit-id-pending'

function writeStoredKitId(kitId: string): void {
  try {
    window.sessionStorage.setItem(KIT_REGISTRATION_RETURN_KIT_ID_KEY, kitId)
  } catch {
    // Private mode can block storage. The page keeps the value for this visit.
  }
}

/** Reads the kit id saved for session-expired resume on the kit ID step. */
export function readKitRegistrationReturnKitId(): string | null {
  if (typeof window === 'undefined') return null
  try {
    const stored = window.sessionStorage.getItem(KIT_REGISTRATION_RETURN_KIT_ID_KEY)?.trim()
    return stored || null
  } catch {
    return null
  }
}

/**
 * Marks the saved kit id for the next kit ID page load.
 * The page uses that value once, then clears it.
 */
export function markKitRegistrationReturnKitIdForResume(): void {
  if (typeof window === 'undefined') return
  if (!readKitRegistrationReturnKitId()) return
  try {
    window.sessionStorage.setItem(KIT_REGISTRATION_RETURN_KIT_ID_PENDING_KEY, '1')
  } catch {
    // Private mode can block storage. The page keeps the value for this visit.
  }
}

/** Reads the kit id only when this page load is the sign-in return. */
export function readKitRegistrationReturnKitIdForResume(): string | null {
  if (typeof window === 'undefined') return null
  try {
    if (window.sessionStorage.getItem(KIT_REGISTRATION_RETURN_KIT_ID_PENDING_KEY) !== '1') {
      return null
    }
  } catch {
    return null
  }
  return readKitRegistrationReturnKitId()
}

/** Saves the kit id for post-login resume and removes it from the address bar query. */
export function persistKitRegistrationReturnKitId(kitId: string): void {
  if (typeof window === 'undefined') return
  const trimmed = kitId.trim()
  if (!trimmed) return
  writeStoredKitId(trimmed)
}

/** Copies `kit_id` from a query string into session storage when present. */
export function persistKitRegistrationReturnKitIdFromSearch(search: string): void {
  const kitId = new URLSearchParams(search).get('kit_id')?.trim()
  if (kitId) persistKitRegistrationReturnKitId(kitId)
}

export function clearKitRegistrationReturnKitId(): void {
  if (typeof window === 'undefined') return
  try {
    window.sessionStorage.removeItem(KIT_REGISTRATION_RETURN_KIT_ID_KEY)
    window.sessionStorage.removeItem(KIT_REGISTRATION_RETURN_KIT_ID_PENDING_KEY)
  } catch {
    // ignore
  }
}
